import * as Sentry from '@sentry/browser';
import { CustomErrorForSentry } from './customErrorForSentry';
export class ErrorLogger {
  static log(error: Error | CustomErrorForSentry) {
    if (error instanceof CustomErrorForSentry) {
        Sentry.captureException(error, {
          tags: {
            errorCode: error.code,
          },
          extra: {
            description: error.message,
            nextSteps: error.nextSteps,
            error: JSON.stringify(error?.error, null, 2),
            ...(error.context || {}),
          },
        });
      } else {
        // Generic fallback for unknown errors
        Sentry.captureException(error);
    }
  }
}
